export default "__VITE_ASSET__99KFMxI5__"